/**
 * FLIP animation: animates an element from a captured "before" rect to its current position.
 * @param {Element} element - The element to animate
 * @param {DOMRect} fromRect - The bounding rect captured before the DOM change
 * @param {number} [duration=250] - Animation duration in ms
 * @returns {Animation}
 */
export function flipAnimate(element, fromRect, duration = 250) {
  const toRect = element.getBoundingClientRect();
  const dx = fromRect.left - toRect.left;
  const dy = fromRect.top - toRect.top;
  return element.animate([{ transform: `translate(${dx}px, ${dy}px)` }, { transform: 'translate(0, 0)' }], {
    duration,
    easing: 'cubic-bezier(0.2, 0, 0, 1)',
  });
}
